import {
  Box,
  PageActions,
  PageContainer,
  PageContent,
  PageContentWrapper,
  PageSubheader,
  PrintButton
} from 'components';
import CustomDataReport from 'components/CustomData/CustomDataReport';
import LanguageContainer from 'components/LanguageContainer/LanguageContainer';
import { PageActionsV2 } from 'components/Layout';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';

import PublicReportPageError from './components/PublicReportPageError';
import { useGetPublicReportQuery_old } from './queries';

type RouteParams =
  | 'tenantCode'
  | 'customerId'
  | 'orderCustomFormId'
  | 'reportId'
  | 'serviceObjectId';

interface Props {
  lang?: string;
}

const PublicReportOld: React.FC<Props> = (props): React.ReactElement => {
  const { lang } = props;

  const params = useParams<RouteParams>();
  const componentToPrint = useRef<HTMLDivElement | null>(null);

  const publicReportQuery = useGetPublicReportQuery_old(
    params.tenantCode || '',
    params.customerId || '',
    params.orderCustomFormId || ''
  );

  const customForm = publicReportQuery.data;

  const getServiceObjectFromCustomForm = () => {
    return customForm?.needsServiceObject && !customForm.multipleServiceObjects
      ? customForm.serviceObjectIds[0]
      : undefined;
  };

  const reportTemplate = customForm?.template.reports?.find((x) => x.id === params.reportId);

  const serviceObjectName =
    params.serviceObjectId &&
    customForm &&
    customForm.relatedData?.order?.serviceObjects.find((x) => x.id === params.serviceObjectId)
      ?.name;

  const title = serviceObjectName ? (
    <div>
      <div className="title">{serviceObjectName}</div>
      <div className="subtitle">{reportTemplate?.name}</div>
    </div>
  ) : (
    <div className="title">{reportTemplate?.name}</div>
  );

  const helmetTitle = serviceObjectName
    ? `${serviceObjectName} - ${reportTemplate?.name || ''}`
    : reportTemplate?.name;

  const serviceObjectId = params.serviceObjectId
    ? params.serviceObjectId
    : getServiceObjectFromCustomForm();

  return (
    <LanguageContainer lang={lang}>
      <PageContainer pageTitle={helmetTitle || ''} className="PublicReportPage">
        <PageSubheader
          title={title}
          hideBackButton
          actions={<PageActionsV2 actions={<PrintButton content={componentToPrint} />} />}
        />
        <PageContentWrapper>
          <PageContent>
            <Box>
              {!customForm || !reportTemplate || publicReportQuery.error ? (
                <PublicReportPageError />
              ) : (
                <CustomDataReport
                  serviceObjectId={serviceObjectId}
                  reportTemplate={reportTemplate}
                  customForm={customForm}
                  ref={componentToPrint}
                  isPublic={true}
                />
              )}
            </Box>
          </PageContent>
        </PageContentWrapper>
      </PageContainer>
    </LanguageContainer>
  );
};

export default PublicReportOld;
